'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { Children, isValidElement, cloneElement } from 'react';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { ThumbnailsHeroVideoThumbnailSlide } from './thumbnails-hero-video-thumbnail-slide.component.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { ThumbnailsHeroBackgroundContainer } from './thumbnails-hero-background-container.component.js';
import { ThumbnailsHeroContentContainer } from './thumbnails-hero-content-container.component.js';
import { ThumbnailsHeroImagesSlidesContainer } from './thumbnails-hero-images-slides-container.component.js';
import { ThumbnailsHeroThumbnailsSlidesContainer } from './thumbnails-hero-thumbnails-slides-container.component.js';
import { Carousel } from '../carousel/carousel.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { CarouselSlide } from '../carousel/carousel-slide.component.js';
import { RenderComp } from '../core/render-comp.component.js';

let g = {
    currentSlide: t.number,
    onSlideChange: t.func,
    accessibleTextForDots: t.arrayOf(t.string.isRequired).isRequired
}, w = Object.keys(g);
const ThumbnailsHero = renderWithRef('ThumbnailsHero', g, (r, l)=>{
    useComponentStylesLoaded('ThumbnailsHero', SWAN_STYLE_KEY_MAP.thumbnailsHero);
    let { currentSlide: g = 0, accessibleTextForDots: y, onSlideChange: T, children: x } = r, S = [], v = [], R = null, j = null;
    return Children.forEach(x, (e)=>{
        if (isValidElement(e)) switch(e.type){
            case ThumbnailsHeroThumbnailsSlidesContainer:
                S.push(...Children.map(e.props.children, (e, o)=>[
                        CarouselSlide,
                        ThumbnailsHeroVideoThumbnailSlide
                    ].includes(e.type) ? cloneElement(e, {
                        key: o,
                        component: e.props.component || 'span'
                    }) : null));
                break;
            case ThumbnailsHeroImagesSlidesContainer:
                v.push(...Children.map(e.props.children, (e, o)=>e.type === CarouselSlide ? cloneElement(e, {
                        key: o
                    }) : null));
                break;
            case ThumbnailsHeroBackgroundContainer:
                R = e;
                break;
            case ThumbnailsHeroContentContainer:
                j = e;
        }
    }), jsxs(RenderComp, {
        root: "div",
        forwardedRef: l,
        propKeysToRemove: w,
        classNames: new Set([
            'swan-thumbnails-hero'
        ]),
        props: r,
        children: [
            R,
            jsx("div", {
                className: "swan-thumbnails-hero-images-carousel-container",
                children: jsx(Carousel, {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    arrows: false,
                    accessibleTextForNext: "",
                    accessibleTextForPrevious: "",
                    accessibleTextForDots: y,
                    customPaging: (o)=>jsx("button", {
                            "aria-label": y[o],
                            children: S[o]
                        }, o),
                    progressIndicator: 'dots',
                    progressIndicatorAlignment: 'left',
                    currentSlide: null != g ? g : 0,
                    beforeChange: null != T ? T : void 0,
                    fade: true,
                    responsive: [
                        {
                            breakpoint: parseInt(tokensRaw.SwanBaseBreakpointMdStart, 10),
                            settings: {
                                fade: false
                            }
                        }
                    ],
                    children: v
                })
            }),
            j
        ]
    });
});

export { ThumbnailsHero };
